// extracted by mini-css-extract-plugin
export default {"paymentPage":"Payment_paymentPage__yy6dn","form":"Payment_form__A1kDa"};